<template>
    <div class="not-found-container">
        <div class="logo-container py-6">
            <v-img v-if="!appStore.isSessionInitialized" class="my-2" max-width="150" :src="require('@/assets/logos/gorate-logo-white.svg')"
                @click="navigate('Dashboard')"></v-img>
        </div>
        <div class="title-container text-h3 pb-3">
          {{ $t('i18n.pageNotFoundTitle') }}
        </div>
        <div class="text-container pb-6">
          {{ $t('i18n.pageNotFoundSubtitle') }}
        </div>
        <router-link to="/">{{ $t('i18n.homepageLinkText') }}</router-link>
    </div>
</template>

<script lang=ts>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/appStore'

export default defineComponent({
  name: 'NotFound',
  setup () {
    const router = useRouter()
    const appStore = useAppStore()
    return {
      router,
      appStore
    }
  },
  methods: {
    navigate (routeName : string) {
      this.router.push({ name: routeName })
    }
  }
})
</script>

<style lang="scss" scoped>
.not-found-container {
    display: grid;
    grid-template-rows: auto auto auto;
    align-items: center;
    justify-content: center;
}
</style>
